import { useEffect, useState } from 'react';
import { promotionInfoStore } from '@/website/store/promotion/promotionInfoStore';
import { Button, useLocalTranslation } from '@jove-frontend/uikit';
import { Box } from '@mui/material';
import { lintrk } from 'nextjs-linkedin-insight-tag';
import { useAnalytics } from 'use-analytics';

type GetQuoteProps = {
  type?: 'primary' | 'secondary';
  onClick?: () => void;
  openQuoteModal: () => void;
};

const LinkedinConversionId = process.env.NX_LINKEDIN_CONVERSION_ID;

export const GetQuoteButton = ({ type = 'primary', openQuoteModal, onClick }: GetQuoteProps) => {
  const { track } = useAnalytics();
  const { $t } = useLocalTranslation();
  const {
    state: { promotionInfo },
  } = promotionInfoStore();
  const [buttonStyles, setButtonStyles] = useState(null);

  /**
   * effects
   */
  useEffect(() => {
    if (promotionInfo) {
      const { quote_button_text_color, quote_button_font_size, quote_button_bg_color } =
        promotionInfo.payload?.website_configuration?.header_information || {};
      setButtonStyles({
        color: quote_button_text_color || '#ffffff',
        fontSize: quote_button_font_size || '14px',
        backgroundColor: quote_button_bg_color || '#CD0D47',
      });
    }
  }, [promotionInfo]);

  /**
   * methods
   */
  const handleClick = () => {
    if (onClick) onClick();

    openQuoteModal?.();
    try {
      track?.('click_get_quote_button');
      lintrk?.('track', { conversion_id: LinkedinConversionId });
    } catch (_) {}
  };

  return !!promotionInfo ? (
    <Box className="ml-4 flex cursor-pointer rounded-full px-5 py-2 font-bold" sx={buttonStyles} onClick={handleClick}>
      {promotionInfo.payload?.website_configuration?.header_information?.quote_button_text || $t('page:GetQuoteButton.get_a_quote')}
    </Box>
  ) : (
    <Button color={type} onClick={handleClick} className="text-sm">
      {$t('page:GetQuoteButton.get_a_quote')}
    </Button>
  );
};
